// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__xqfbv","search":"Settings_search__2Owih","filter":"Settings_filter__3jDIm"};